var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "login-container"
  }, [_c('b-card', {
    staticClass: "text-center login-card"
  }, [_c('b-card-body', [_c('p', [_vm._v("У вас нет доступа к этому приложению.")]), _c('router-link', {
    staticClass: "btn btn-success btn-block",
    attrs: {
      "to": "/login",
      "tag": "button"
    }
  }, [_vm._v("Назад")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }